/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Sports_MassageInputs */

const en_service_type_sports_massage = /** @type {(inputs: Service_Type_Sports_MassageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports massage`)
};

const pl_service_type_sports_massage = /** @type {(inputs: Service_Type_Sports_MassageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masaż sportowy`)
};

/**
* | output |
* | --- |
* | "Sports massage" |
*
* @param {Service_Type_Sports_MassageInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_sports_massage = /** @type {((inputs?: Service_Type_Sports_MassageInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Sports_MassageInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_sports_massage(inputs)
	return en_service_type_sports_massage(inputs)
});